import * as React from "react";

function SvgLastCapturedImage(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 26 34" fill="none" {...props}>
      <path
        d="M0 2.39C0 1.16 1.145 0 2.318 0h20.864C24.355 0 25.5 1.16 25.5 2.318v20.864c0 1.173-1.16 2.318-2.318 2.318h-.515v-1.16h.515c.58 0 1.159-.579 1.159-1.158V2.318c0-.58-.58-1.159-1.16-1.159H2.319c-.58 0-1.159.58-1.159 1.16v20.863c0 .58.58 1.159 1.16 1.159h.514V25.5h-.515C1.16 25.5 0 24.355 0 23.182V2.39z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.182 3.477v16.227l-6.955-6.954-2.318 2.318-3.477-4.636-8.114 9.272V3.477c0-.58.58-1.159 1.16-1.159h18.545c.58 0 1.159.58 1.159 1.16zm-4.854 5.289a2.39 2.39 0 100-4.782 2.39 2.39 0 000 4.782z"
        fill="#fff"
      />
      <path
        d="M12.75 31.167a3.545 3.545 0 01-3.542-3.542 3.545 3.545 0 013.542-3.542 3.545 3.545 0 013.542 3.542 3.545 3.545 0 01-3.542 3.542zm0-4.959a1.417 1.417 0 10.001 2.835 1.417 1.417 0 00-.001-2.835z"
        fill="#fff"
      />
      <path
        d="M18.77 34H6.73a2.482 2.482 0 01-2.48-2.48v-6.728a2.482 2.482 0 012.48-2.48h1.062c.11 0 .215-.052.282-.141l1.333-1.506a2.491 2.491 0 011.854-.832h2.978c.707 0 1.383.304 1.854.832l1.277 1.437c.123.157.228.21.338.21h1.063a2.482 2.482 0 012.479 2.478v6.73A2.482 2.482 0 0118.77 34zM6.73 24.438a.354.354 0 00-.355.354v6.729c0 .195.159.354.354.354h12.042a.354.354 0 00.354-.354v-6.73a.354.354 0 00-.354-.353h-1.063a2.486 2.486 0 01-1.983-.994l-1.22-1.367a.36.36 0 00-.266-.119H11.26c-.1 0-.198.044-.266.12l-1.277 1.436c-.408.552-1.149.924-1.926.924H6.729z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgLastCapturedImage;
